import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FirstScreenNew.module.css';
import avi from "../images/אבי לוי דף ראשי.png";

const HeroSection = () => {
  const navigate = useNavigate();
  const [showContactForm, setShowContactForm] = useState(false);
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    city: '',
    experience: '',
    goal: '',
    timeCommitment: '',
    disciplineAware: '',
    openQuestion: ''
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [agreed, setAgreed] = useState(false);

  const serverUrl = "https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead";
  const reciver = "riseupnon@gmail.com";

  const handleWhatsAppClick = () => {
    setShowContactForm(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = 'נא להזין שם מלא';
    }

    const phoneRegex = /^0(5\d|[23489])\d{7}$/;
    if (!formData.phone.trim()) {
      newErrors.phone = 'נא להזין מספר טלפון';
    } else if (!phoneRegex.test(formData.phone.replace(/[-\s]/g, ''))) {
      newErrors.phone = 'נא להזין מספר טלפון תקין';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = 'נא להזין אימייל';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'נא להזין אימייל תקין';
    }

    if (!formData.city.trim()) {
      newErrors.city = 'נא להזין עיר';
    }

    if (!formData.experience) {
      newErrors.experience = 'נא לבחור תשובה';
    }

    if (!formData.goal) {
      newErrors.goal = 'נא לבחור תשובה';
    }

    if (!formData.timeCommitment) {
      newErrors.timeCommitment = 'נא לבחור תשובה';
    }

    if (!formData.disciplineAware) {
      newErrors.disciplineAware = 'נא לבחור תשובה';
    }

    if (!agreed) {
      newErrors.agreed = 'יש לאשר את תנאי השימוש';
    }

    setErrors(newErrors);
    
    if (Object.keys(newErrors).length > 0) {
      const firstErrorField = Object.keys(newErrors)[0];
      setTimeout(() => {
        const errorElement = document.querySelector(`[name="${firstErrorField}"]`) || 
                            document.querySelector(`.${styles.errorText}`);
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          if (errorElement.focus) {
            errorElement.focus();
          }
        }
      }, 100);
    }
    
    return Object.keys(newErrors).length === 0;
  };

  const handleContactSubmit = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    const detailedInfo = `
עיר: ${formData.city}
---
1. ניסיון במסחר: ${formData.experience}
2. מטרה עיקרית: ${formData.goal}
3. זמן שבועי ללמידה: ${formData.timeCommitment}
4. מודעות למשמעת נדרשת: ${formData.disciplineAware}
5. שאלה פתוחה: ${formData.openQuestion || 'לא צוין'}
    `.trim();

    const serverData = {
      name: formData.fullName,
      phone: formData.phone.replace(/[-\s]/g, ''),
      email: formData.email,
      reason: detailedInfo,
      reciver: reciver
    };

    try {
      const response = await fetch(serverUrl, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(serverData)
      });

      if (response.ok) {
        setSubmitted(true);
        
        // מעבר לדף תודה אחרי 1.5 שניות
        setTimeout(() => {
          navigate('/תודה');
        }, 1500);
      } else {
        throw new Error('Failed to submit');
      }
    } catch (error) {
      alert("התרחשה שגיאה, אנא נסו שוב מאוחר יותר");
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className={styles.hero}>
      {/* Subtle Background Glows */}
      <div className={styles.bgGlow1}></div>
      <div className={styles.bgGlow2}></div>
      
      {/* Main Content Container */}
      <div className={styles.container}>
        {/* Text Content Side */}
        <div className={styles.textContent}>
          {/* Badge */}
          <div className={styles.badge}>
            <span className={styles.badgeDot}></span>
            במיוחד לחברה צעירים שרוצים להגשים את הפוטנציאל שלהם
          </div>

          {/* Pain Point Hook */}
          <p className={styles.painHook}>
            תמיד חלמת לדעת לסחור בשוק ההון ולעבוד מכל מקום בעולם?
            <br />
            <span className={styles.painStrong}>נמאס לך לראות חברים מתקדמים בזמן שאתה תקוע במקום?</span>
          </p>

          {/* Mobile Hero Image - Behind Text */}
          <div className={styles.mobileImageSection}>
            {/* Stock Cards */}
            <div className={styles.mobileStockCard1}>
              <span className={styles.stockTicker}>AAPL</span>
              <span className={styles.stockValue}>+2.4%</span>
              <svg viewBox="0 0 80 30" className={styles.stockChart}>
                <polyline
                  fill="none"
                  stroke="#00C462"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  points="0,25 15,20 25,22 40,12 55,15 65,8 80,5"
                />
              </svg>
            </div>
            
            <div className={styles.mobileStockCard2}>
              <span className={styles.stockTicker}>TSLA</span>
              <span className={styles.stockValue}>+5.8%</span>
              <svg viewBox="0 0 100 35" className={styles.stockChart}>
                <polyline
                  fill="none"
                  stroke="#00C462"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  points="0,30 20,25 35,28 50,18 65,20 80,10 100,5"
                />
              </svg>
            </div>
            
            <div className={styles.mobileStockCard3}>
              <span className={styles.stockTicker}>NVDA</span>
              <span className={styles.stockValue}>+3.7%</span>
              <svg viewBox="0 0 60 25" className={styles.stockChart}>
                <polyline
                  fill="none"
                  stroke="#00C462"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  points="0,20 12,18 24,12 36,14 48,8 60,5"
                />
              </svg>
            </div>
            
            <img 
              src={avi} 
              alt="אבי לוי - מומחה למסחר בשוק ההון"
              className={styles.mobileHeroImage}
            />
          </div>

          {/* Glass Content Container - Text content with glass effect */}
          <div className={styles.glassContentContainer}>
            {/* Main Headline */}
            <h1 className={styles.headline}>
              הפוך ל<span className={styles.highlight}>סוחר רווחי</span>
              <br />
              <span className={styles.headlineSecond}>ותעבוד מכל מקום בעולם</span>
            </h1>

            {/* Subheadline */}
            <p className={styles.subheadline}>
              לימודי מסחר יומי בשוק ההון בכיתות קטנות,
              <br />
              <span className={styles.subStrong}>עם ליווי צמוד ותגבורים שבועיים למשך שנה שלמה</span>
            </p>

            {/* Guarantee Box */}
            <div className={styles.guaranteeBox}>
              <span className={styles.guaranteeIcon}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                </svg>
              </span>
              <span className={styles.guaranteeText}>
                100% אחריות - תהיה סוחר רווחי או קבל החזר כספי מלא
              </span>
            </div>

            {/* CTA Button */}
            <button 
              onClick={handleWhatsAppClick}
              className={styles.ctaButton}
            >
              <span>כן, אני רוצה להפוך לסוחר רווחי!</span>
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
              </svg>
            </button>

            {/* Trust Indicators */}
            <div className={styles.trustIndicators}>
              <div className={styles.trustItem}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
                <span>שיעורים פרונטליים</span>
              </div>
              <div className={styles.trustItem}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                </svg>
                <span>עד 10 תלמידים בכיתה</span>
              </div>
              <div className={styles.trustItem}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
                <span>תגבורים שבועיים לשנה</span>
              </div>
            </div>
          </div>
        </div>

        {/* Desktop Image Side */}
        <div className={styles.imageContent}>
          <div className={styles.imageGlow}></div>
          
          {/* Stock Cards Around Avi */}
          <div className={styles.stockCard1}>
            <span className={styles.stockTicker}>AAPL</span>
            <span className={styles.stockValue}>+2.4%</span>
            <svg viewBox="0 0 80 30" className={styles.stockChart}>
              <polyline
                fill="none"
                stroke="#00C462"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="0,25 15,20 25,22 40,12 55,15 65,8 80,5"
              />
            </svg>
          </div>
          
          <div className={styles.stockCard2}>
            <span className={styles.stockTicker}>TSLA</span>
            <span className={styles.stockValue}>+5.8%</span>
            <svg viewBox="0 0 100 35" className={styles.stockChart}>
              <polyline
                fill="none"
                stroke="#00C462"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="0,30 20,25 35,28 50,18 65,20 80,10 100,5"
              />
            </svg>
          </div>
          
          <div className={styles.stockCard3}>
            <span className={styles.stockTicker}>NVDA</span>
            <span className={styles.stockValue}>+3.7%</span>
            <svg viewBox="0 0 60 25" className={styles.stockChart}>
              <polyline
                fill="none"
                stroke="#00C462"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
                points="0,20 12,18 24,12 36,14 48,8 60,5"
              />
            </svg>
          </div>
          
          <div className={styles.imageWrapper}>
            <img 
              src={avi} 
              alt="אבי לוי - מומחה למסחר בשוק ההון"
              className={styles.heroImage}
            />
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className={styles.scrollIndicator}>
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
        </svg>
      </div>

      {/* Contact Form Overlay */}
      <div className={`${styles.contactOverlay} ${showContactForm ? styles.active : ''}`}>
        <div className={styles.contactForm}>
          <button className={styles.closeButton} onClick={() => setShowContactForm(false)}>
            ×
          </button>

          <div className={styles.formHeader}>
            <h2 className={styles.formTitle}>מלא את הטופס וקבל התאמה אישית</h2>
            <p className={styles.formSubtitle}>למסלול מסחר מקצועי עם חשבון ממומן</p>
          </div>

          <div className={styles.formScrollContainer}>
            {/* Personal Details Section */}
            <div className={styles.formSection}>
              <h3 className={styles.sectionTitle}>
                <span className={styles.sectionIcon}>
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                </span>
                פרטים אישיים
              </h3>

              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>שם מלא</label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className={`${styles.formInput} ${errors.fullName ? styles.inputError : ''}`}
                    placeholder="השם המלא שלך"
                    disabled={isSubmitting || submitted}
                  />
                  {errors.fullName && <p className={styles.errorText}>{errors.fullName}</p>}
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>טלפון</label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className={`${styles.formInput} ${errors.phone ? styles.inputError : ''}`}
                    placeholder="050-1234567"
                    disabled={isSubmitting || submitted}
                  />
                  {errors.phone && <p className={styles.errorText}>{errors.phone}</p>}
                </div>
              </div>

              <div className={styles.formRow}>
                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>אימייל</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`${styles.formInput} ${errors.email ? styles.inputError : ''}`}
                    placeholder="your@email.com"
                    disabled={isSubmitting || submitted}
                  />
                  {errors.email && <p className={styles.errorText}>{errors.email}</p>}
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.formLabel}>עיר</label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                    className={`${styles.formInput} ${errors.city ? styles.inputError : ''}`}
                    placeholder="עיר מגורים"
                    disabled={isSubmitting || submitted}
                  />
                  {errors.city && <p className={styles.errorText}>{errors.city}</p>}
                </div>
              </div>
            </div>

            {/* Question 1 */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>1</span>
                איזה ניסיון יש לך במסחר בשוק ההון?
              </h3>
              <div className={styles.radioGroup}>
                <label className={`${styles.radioOption} ${formData.experience === 'אין לי ניסיון בכלל' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="experience"
                    value="אין לי ניסיון בכלל"
                    checked={formData.experience === 'אין לי ניסיון בכלל'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>אין לי ניסיון בכלל</span>
                </label>
                <label className={`${styles.radioOption} ${formData.experience === 'סוחר מעט, אך עדיין לא עקבי' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="experience"
                    value="סוחר מעט, אך עדיין לא עקבי"
                    checked={formData.experience === 'סוחר מעט, אך עדיין לא עקבי'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>סוחר מעט, אך עדיין לא עקבי</span>
                </label>
                <label className={`${styles.radioOption} ${formData.experience === 'יש לי ניסיון ורוצה להתקדם למסחר מקצועי עם חשבונות ממומנים' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="experience"
                    value="יש לי ניסיון ורוצה להתקדם למסחר מקצועי עם חשבונות ממומנים"
                    checked={formData.experience === 'יש לי ניסיון ורוצה להתקדם למסחר מקצועי עם חשבונות ממומנים'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>יש לי ניסיון ורוצה להתקדם למסחר מקצועי עם חשבונות ממומנים</span>
                </label>
              </div>
              {errors.experience && <p className={styles.errorText}>{errors.experience}</p>}
            </div>

            {/* Question 2 */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>2</span>
                מה המטרה העיקרית שלך בלימודי מסחר?
              </h3>
              <div className={styles.radioGroup}>
                <label className={`${styles.radioOption} ${formData.goal === 'יצירת הכנסה נוספת מהצד' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="goal"
                    value="יצירת הכנסה נוספת מהצד"
                    checked={formData.goal === 'יצירת הכנסה נוספת מהצד'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>יצירת הכנסה נוספת מהצד</span>
                </label>
                <label className={`${styles.radioOption} ${formData.goal === 'הפיכת המסחר לקריירה עיקרית' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="goal"
                    value="הפיכת המסחר לקריירה עיקרית"
                    checked={formData.goal === 'הפיכת המסחר לקריירה עיקרית'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>הפיכת המסחר לקריירה עיקרית</span>
                </label>
                <label className={`${styles.radioOption} ${formData.goal === 'עמידה בתנאי חשבון ממומן וקבלת הקצאת הון' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="goal"
                    value="עמידה בתנאי חשבון ממומן וקבלת הקצאת הון"
                    checked={formData.goal === 'עמידה בתנאי חשבון ממומן וקבלת הקצאת הון'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>עמידה בתנאי חשבון ממומן וקבלת הקצאת הון</span>
                </label>
              </div>
              {errors.goal && <p className={styles.errorText}>{errors.goal}</p>}
            </div>

            {/* Question 3 */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>3</span>
                כמה זמן ריאלי אתה מוכן להקדיש ללמידה ולתרגול בשבוע?
              </h3>
              <div className={styles.radioGroup}>
                <label className={`${styles.radioOption} ${formData.timeCommitment === 'עד שעתיים' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="timeCommitment"
                    value="עד שעתיים"
                    checked={formData.timeCommitment === 'עד שעתיים'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>עד שעתיים</span>
                </label>
                <label className={`${styles.radioOption} ${formData.timeCommitment === '3-5 שעות' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="timeCommitment"
                    value="3-5 שעות"
                    checked={formData.timeCommitment === '3-5 שעות'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>3-5 שעות</span>
                </label>
                <label className={`${styles.radioOption} ${formData.timeCommitment === 'יותר מ-5 שעות' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="timeCommitment"
                    value="יותר מ-5 שעות"
                    checked={formData.timeCommitment === 'יותר מ-5 שעות'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>יותר מ-5 שעות</span>
                </label>
              </div>
              {errors.timeCommitment && <p className={styles.errorText}>{errors.timeCommitment}</p>}
            </div>

            {/* Question 4 */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>4</span>
                האם ברור לך שמדובר בתהליך לימודי ומעשי הדורש משמעת, תרגול והתמדה לאורך זמן?
              </h3>
              <div className={styles.radioGroup}>
                <label className={`${styles.radioOption} ${formData.disciplineAware === 'כן' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="disciplineAware"
                    value="כן"
                    checked={formData.disciplineAware === 'כן'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>כן</span>
                </label>
                <label className={`${styles.radioOption} ${formData.disciplineAware === 'לא בטוח' ? styles.radioSelected : ''}`}>
                  <input
                    type="radio"
                    name="disciplineAware"
                    value="לא בטוח"
                    checked={formData.disciplineAware === 'לא בטוח'}
                    onChange={handleInputChange}
                    disabled={isSubmitting || submitted}
                  />
                  <span className={styles.radioCircle}></span>
                  <span className={styles.radioText}>לא בטוח</span>
                </label>
              </div>
              {errors.disciplineAware && <p className={styles.errorText}>{errors.disciplineAware}</p>}
            </div>

            {/* Question 5 - Open Question */}
            <div className={styles.formSection}>
              <h3 className={styles.questionTitle}>
                <span className={styles.questionNumber}>5</span>
                שאלה פתוחה
              </h3>
              <p className={styles.questionSubtext}>
                למה החלטת להתחיל ללמוד מסחר דווקא עכשיו, ומה היעד שלך בהתקדמות לחשבון ממומן?
              </p>
              <textarea
                name="openQuestion"
                value={formData.openQuestion}
                onChange={handleInputChange}
                className={styles.formTextarea}
                placeholder="ספר לנו..."
                rows="4"
                disabled={isSubmitting || submitted}
              />
            </div>

            {/* Privacy Checkbox */}
            <div className={styles.privacyCheckbox}>
              <label className={styles.checkboxLabel}>
                <input
                  type="checkbox"
                  name="agreed"
                  checked={agreed}
                  onChange={() => setAgreed(!agreed)}
                  disabled={isSubmitting || submitted}
                />
                <span className={styles.checkboxCustom}></span>
                <span>קראתי ואני מאשר/ת את תנאי השימוש ומדיניות הפרטיות</span>
              </label>
              {errors.agreed && <p className={styles.errorText}>{errors.agreed}</p>}
            </div>

            {/* Submit Button */}
            <div className={styles.formButtons}>
              <button
                className={`${styles.submitButton} ${isSubmitting ? styles.submitting : ''} ${submitted ? styles.submitted : ''}`}
                onClick={handleContactSubmit}
                disabled={isSubmitting || submitted}
              >
                {isSubmitting ? (
                  <>
                    <span className={styles.spinner}></span>
                    שולח...
                  </>
                ) : submitted ? (
                  <>
                    <svg viewBox="0 0 24 24" fill="currentColor" className={styles.successIcon}>
                      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
                    </svg>
                    נשלח בהצלחה!
                  </>
                ) : (
                  'שליחה וקבלת התאמה אישית'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;